import { ContentFilters } from 'components';
import { NotificationListFilterForm } from 'features/notification/components/notification-main-filter/notification-filter-form';
import { NotificationFilterFormValues } from 'features/notification/components/type';
import { useState } from 'react';
import { CompanyType } from 'types';
type VendingTopBarProps = {
  getInitialFilterValues: NotificationFilterFormValues;
  handleFilter: (values: NotificationFilterFormValues) => void;
  refetch: any
};

export const NotificationTopBar = ({
  getInitialFilterValues,
  handleFilter,

}: VendingTopBarProps) => {

  useState<CompanyType>();

  const formId = 'users-filters-form';


  return (
    <>



      <ContentFilters formId={formId}>
        <NotificationListFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};
